<!-- Swiper -->
<div class="swiper-container-similars">
    <div class="swiper-wrapper">
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>
        <div class="swiper-slide-similars">Slide 1</div>

    </div>
    <!-- Add Pagination -->
    <div class="swiper-pagination"></div>
    <!-- Add Arrows -->
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
</div>